import { AutoComplete } from "../openings/AutoComplete";
import { css } from "@emotion/css";
import { grey } from "@mui/material/colors";
import { jsx as _jsx } from "react/jsx-runtime";
export function NativeAutoComplete(props) { return /*#__PURE__*/ _jsx(AutoComplete, { useNativeInput: true, placeholder: props.placeholder, search: props.onSearch, className: groupNumberClass, value: null, equals: (a, b) => a.id === b.id, makeLabel: props.makeLabel, onSelect: props.onAssign, onCreate: props.onCreate }); }
const groupNumberClass = css({ "&::placeholder": { fontStyle: "italic", color: grey["500"] } });
